module.exports = __webpack_public_path__ + "img/25.81d16da7.png";